<template>
    <div>
        <spinner v-if="inDownload"></spinner>
        <input
            type="button"
            value="Download States.json"
            class="btn btn-primary brfss-button"
            v-on:click="downloadStates"
            title="Download the states json file"
        />
        <input
            type="button"
            value="Download VariableYearSource.json"
            class="btn btn-primary brfss-button"
            v-on:click="downloadVariableYearSource"
            title="Download the variables json file"
        />
    </div>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import current from '@/scripts/current';
import levelValidator from '@/scripts/levelValidator';
import variableSelectionHelper from '@/scripts/variableSelectionHelper';
import commonApiHelper from '@/scripts/commonApiHelper';
import spinner from '@/components/sub/spinner';
import store from '@/store';
import $ from 'jquery';
import { json } from 'body-parser';

export default {
    components: {
        spinner: spinner
    },
    data: function () {
        var vm = this;

        current.initializeValidateVariables('Download Updated API Files');

        var vmData = {
            mismatched: null,
            inDownload: false
        };

        return vmData;
    },
    methods: { downloadStates, downloadVariableYearSource }
};

function downloadStates() {
    loadFromApi('states', 'states', (s) => s.states, true, processData1);
}
function downloadVariableYearSource() {
    loadFromApi('variableYearSource', 'variableYears', (s) => wrapArray(s));

    var theObject = {};

    // loadFromApi(
    //     'variableYearSource',
    //     'variableYears',
    //     (s) => wrapArray(s),
    //     false,
    //     //theObject,
    //     processData1
    // );

    // stateYearCounts1;
    // stateYearCounts2;

    // variableGroups;
    // levelCounts;
    // levels;
    // variables;
    // variableYears;
    // yearVariables;
}

function wrapArray(s) {
    s = s.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
    var value = '[' + s.substring(0, s.length - 1) + ']';
    console.log('wrapArray 1', value);
    var results = JSON.parse(value);
    console.log('wrapArray 2', results);
    return results;
}

function loadFromApi(fileName, apiName, selection, isJson, processData) {
    let timeoutSeconds = 0; // No limit
    let parameters = [];
    commonApiHelper.addServiceParameters(parameters, 'brfss_p.api.sas');
    parameters.push({ queryCode: 'type', value: apiName });
    parameters.push({
        queryCode: 'output_format',
        value: isJson ? 'json' : 'text'
    });
    let apiFormData = commonApiHelper.toQueryString(parameters);
    store.dispatch('display/setIsLoading', true);
    $.ajax({
        url: process.env.VUE_APP_SAS_BROKER, //+ '?' + queryStringParms,
        type: 'POST',
        //        dataType: 'text',
        timeout: timeoutSeconds * 1000,
        data: apiFormData,
        success: function (data) {
            //processData(data, selection, fileName);

            //var jsonData = selection(data);
            //var formatted = format(JSON.stringify(jsonData));

            var formatted = format(JSON.stringify(selection(data)));
            console.log('results are', formatted);
            downloadFile(fileName, formatted);
            store.dispatch('display/setIsLoading', false);

            // loadFromApi(vmData, data.variables);
            // let variables = data.variables;
        },
        error: function (jqXHR) {
            console.log('API Error', jqXHR);
            store.dispatch('display/setIsLoading', false);
        }
    });
}

function processData1(data, selection, fileName) {
    var jsonData = selection(data);
    var formatted = format(JSON.stringify(jsonData));
    //var formatted = format(JSON.stringify(selection(data)));
    console.log('processData1', data, formatted);
    console.log('results are', formatted);
    downloadFile(fileName, formatted);
    //var results = data;
    store.dispatch('display/setIsLoading', false);
}

function formatChar(c, prev) {
    if (c === '{') return '\n    { ';
    if (c === '}') return ' }';
    if (prev === '}' && c === ',') return ',';
    if (c === ']') return '\n]';
    if (c === ':') return ': ';
    if (c === ',') return ', ';
    //console.log('addChar', results, c);
    else return c;
}

function format(u) {
    //u = unformatted
    var results = '';
    var prev = '';
    for (var i = 0; i < u.length; ++i) {
        results += formatChar(u[i], prev);
        prev = u[i];
        //addChar(results, u[i]);
    }
    return results;
}

function downloadFile(name, data) {
    if (process.env.NODE_ENV && process.env.NODE_ENV !== 'development') return;
    //const data = JSON.stringify(text);
    const blob = new Blob([data], { type: 'text/plain' });
    const e = document.createEvent('MouseEvents');
    const a = document.createElement('a');
    a.download = name + '.json';
    a.href = window.URL.createObjectURL(blob);
    a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
    e.initEvent(
        'click',
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
    );
    a.dispatchEvent(e);
}
</script>

<style scoped>
td {
    padding: 5px 10px 5px 10px;
}

thead {
    font-weight: bold;
}
</style>
